function waitForSlideSDK(timeout = 5000, interval = 50) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    function check() {
      if (window.Slide) return resolve(window.Slide);
      if (Date.now() - start > timeout) return reject(new Error("Slide SDK not loaded"));
      setTimeout(check, interval);
    }
    check();
  });
}

export async function getSlideConfigs() {
  const Slide = await waitForSlideSDK();
  const slide = Slide();
  return slide;
}
